export const CLOSE_STAGE_UPDATED_SUBJECT = "organization.close-stage-updated";

export interface CloseStageUpdatedEvent {
    closeId: string;
    organizationId: string;
    /** ISO-8601 string or null */
    finishedAt: string | null;
    closeStageId: string | null;
}
